import * as Yup from 'yup'
import { useFormik } from "formik";
import Field from "../../../../../form/fields/Field";
import { UTCDate } from '@date-fns/utc';
import { Alert, DisplayDictionary } from '../../../../../..';
import { store } from '../../../../../../stores/Store';
import Ajax from '../../../../../../Ajax';
import React from 'react';

export default function WorkflowSetup ({caseNode}) {

    const [saveScheduled, setSaveScheduled] = React.useState(false)
    const autoSaveTimer = React.useRef<NodeJS.Timeout>()

    const formik = useFormik({
        initialValues: {
            name: caseNode.name,
            notes: caseNode?.notes,
            type: caseNode?.type,
            targetDate: caseNode?.targetDate ? new UTCDate(caseNode?.targetDate) : null,
            targetDateDescription: caseNode?.targetDateDescription
        },

        validationSchema: Yup.object({
            name: Yup.string().required("This field is required"),
            notes: Yup.string().nullable(),
            type: Yup.string().nullable(),
            targetDate: Yup.date().min(new UTCDate(), "Target date must be in the future").max(new UTCDate("2090-01-01"), "Choose a closer target date").nullable(),
            targetDateDescription: Yup.string().nullable(),
        }),

        onSubmit: async (values, actions) => {

            var updatedCase = {...caseNode, ...values}

            await Ajax.Node.Edit("case", updatedCase).then((response) => {
                store.NodeStore.refreshFolderNode()
            }).catch((response) => {
                Alert({message: response.data?.detail ? response.data.detail : "Couldn't update case"})
            })

            formik.resetForm()
            formik.setValues(values)
            setSaveScheduled(false)
        }
    })

    const handleChange = (e) => {
        formik.setFieldValue(e.target.name, e.target.value).then((errors) => {
            if (!Object.keys(errors).length) {
                scheduleSave()
            } else {
                setSaveScheduled(false)
                clearTimeout(null)
            }
        })
    }

    const scheduleSave = () => {
        setSaveScheduled(true)

        if (autoSaveTimer.current) {
            clearTimeout(autoSaveTimer.current)
        }
        autoSaveTimer.current = setTimeout(() => {
            formik.handleSubmit()
            clearTimeout(autoSaveTimer.current)
        }, 2000)
    }

    return (
        <div style={{display: "grid", gap: "5px", maxWidth: "300px"}}>
            <Field.Date
                formik
                name="targetDate"
                value={formik.values.targetDate}
                warning={formik.errors.targetDate ? formik.errors.targetDate : ""}
                label="Target date"
                onChange={(e) => {
                    e.target.name = "targetDate"
                    console.log(e.target.name)
                    handleChange(e)
                }} />

            <Field.Text
                formik
                // rows={2}
                name="targetDateDescription"
                value={formik.values.targetDateDescription}
                warning={formik.errors.targetDateDescription ? formik.errors.targetDateDescription : ""}
                label="Target date description (Optional)"
                onChange={handleChange} />
                
            {/* <Field.Select
                formik
                name="targetDateDescription"
                value={formik.values.targetDateDescription}
                warning={formik.errors.targetDateDescription ? formik.errors.targetDateDescription : false}
                label="Target date description"
                onChange={handleChange}
                options={DisplayDictionary("case_target_date_description", true)} /> */}
            
            <small style={{height: "12px"}}>
                {saveScheduled ? "Saving..." : ""}
            </small>
        </div>
    )
}